import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import ArticlesBanner from './components/ArticlesBanner';
import About from './components/About';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import PrivacyPolicy from './components/PrivacyPolicy';
import RepairArticle from './pages/RepairArticle';
import VirusArticle from './pages/VirusArticle';
import MaintenanceArticle from './pages/MaintenanceArticle';
import AICoursesArticle from './pages/AICoursesArticle';
import { LanguageProvider } from './contexts/LanguageContext';
import './index.css';

// Component to handle scrolling to sections
function ScrollToSection() {
  const location = useLocation();

  useEffect(() => {
    // Extract hash from location (e.g., /#services becomes #services)
    const hash = location.hash;
    
    if (hash) {
      // Remove the # and find the element
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      
      if (element) {
        // Wait a bit for the page to render
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    } else {
      // If no hash, scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  return null;
}

function HomePage() {
  return (
    <>
      <div id="home">
        <Hero />
      </div>
      <div id="services">
        <Services />
      </div>
      <ArticlesBanner />
      <div id="about">
        <About />
      </div>
      <div id="pricing">
        <Pricing />
      </div>
      <div id="contact">
        <Contact />
      </div>
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToSection />
        <div className="min-h-screen bg-gray-50">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/reparacion-pc-la-manga" element={<RepairArticle />} />
            <Route path="/eliminacion-virus-cartagena" element={<VirusArticle />} />
            <Route path="/mantenimiento-empresarial-san-javier" element={<MaintenanceArticle />} />
            <Route path="/cursos-ia-murcia" element={<AICoursesArticle />} />
          </Routes>
          <Footer />
          <CookieBanner />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;